import React from 'react'
import { withRouter } from 'react-router'
import Swal from 'sweetalert2'
import Constant from '../../Constant.js'
import axios from 'axios'
import Toggle from 'react-toggle'
import Button from '../../common/CustomComponents/Button.js'

class VoucherAdd extends React.Component {
  state = {
    isData: false,
    id: 0,
    name: '',
    no_of_vouchers: 0,
    amount: 10,
    is_active: true,
  }

  handleChange = (event) => {
    if (event.target.name === 'amount') {
      this.setState({ [event.target.name]: event.target.value })
    } else if (event.target.name !== 'amount') {
      this.setState({ [event.target.name]: event.target.value })
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.editVoucherId != this.props.editVoucherId && this.props.editVoucherId) {
      this.setState({
        id: this.props.editVoucherId,
        name: this.props.editVoucherData.name,
        amount: this.props.editVoucherData.amount,
      })
    }
  }

  addVoucher = () => {
    let data = {
      name: this.state.name,
      no_of_vouchers: this.state.no_of_vouchers,
      amount: this.state.amount,
      is_active: this.state.is_active,
    }

    this.setState({ isData: true })
    if (this.props.editVoucherId) {
      data = {
        ...data,
        id: this.state.id,
      }
      axios
        .put(Constant.getAPI() + '/admin/edit-voucher', data, {
          headers: {Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status) {
            Swal.fire({
              title: 'Voucher Updated Successfully!',
              icon: 'success',
              text: '',
              type: 'success',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
          this.resetForm()
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else {
      axios
        .post(Constant.getAPI() + '/admin/add-voucher', data, {
          headers: {Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status) {
            Swal.fire({
              title: 'Voucher Added Successfully!',
              icon: 'success',
              text: '',
              type: 'success',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
          this.resetForm()
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  onSaveData = () => {
    if (!this.state.amount || this.state.amount < 1) {
      Swal.fire({
        title: 'Invalid Voucher Amount',
        icon: 'error',
        text: 'Amount should be greater than zero',
        type: 'error',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })
      return false
    } else if (!this.props.editVoucherId && (!this.state.no_of_vouchers || this.state.no_of_vouchers < 1)) {
      Swal.fire({
        title: 'Invalid No Of Vouchers',
        icon: 'error',
        text: 'No of vouchers should be greater than zero',
        type: 'error',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })
      return false
    } else if (!this.state.name) {
      Swal.fire({
        title: 'Invalid Voucher Name',
        icon: 'error',
        text: 'Voucher name is required',
        type: 'error',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })
      return false
    }
    this.addVoucher()
  }

  clearVoucherDetails = () => {
    this.setState(
      {
        name: '',
        no_of_vouchers: 0,
        amount: 0,
        is_active: true,
      },
      () => {
        this.props.clearEdit()
      }
    )
  }

  resetForm = () => {
    this.setState({
      name: '',
      no_of_vouchers: 0,
      amount: 0,
      is_active: true,
    })
    this.props.reloadList()
  }

  render() {
    return (
      <div className="">
        <div className="card-body">
          <div className="row mt-3">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Name</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    placeholder="Name"
                    onChange={this.handleChange}
                    value={this.state.name}
                  />
                </div>
              </div>
            </div>
            {!this.props.editVoucherId && (
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">No of Vouchers</label>
                  <div className="col-sm-9">
                    <input
                      type="number"
                      className="form-control"
                      name="no_of_vouchers"
                      placeholder="No of Vouchers"
                      onChange={this.handleChange}
                      value={this.state.no_of_vouchers}
                      min={0}
                    />
                  </div>
                </div>
              </div>
            )}
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Voucher Amount</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    name="amount"
                    placeholder="Voucher Amount"
                    onChange={this.handleChange}
                    value={this.state.amount}
                    min={10}
                    max={1000}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Status</label>
                <div className="col-sm-9">
                  <Toggle
                    className="ml-2 form-control"
                    name="is_active"
                    id="is_active"
                    onChange={() => {
                      this.setState({
                        is_active: !this.state.is_active,
                      })
                    }}
                    checked={this.state.is_active}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 text-right">
              <Button
                disabled={this.state.isData}
                onClick={this.onSaveData}
                startIcon={<i className="ti-save"></i>}
              >
                Save
              </Button>
              <Button onClick={this.clearVoucherDetails}>Clear</Button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(VoucherAdd)
